<script>
    import { onMount } from "svelte";
    import { fetchData } from '../utils/functions'

    export let description;
    export let data;
    export let context;

    const headers = data[0]
    const rows = data.slice(1)

    const formatDescription = (string) => {
        let newString = string;
        newString = newString.replace('<country>', `<strong>${context.country.name}</strong>`);
        newString = newString.replace('<type_of_trade>', context.type_of_trade);
        newString = newString.replace('<year>', context.year);
        return newString;
    }

    const isNumber = (string) => {
        return parseFloat(string) ? true : false;
    }

    const hasPercentage = (string) => {
        const regex = new RegExp('(\d*)(\s?)(\(\d*\.?\d*%\))');
        return regex.test(string);
    }

    // Calculates the total of a table column
    const calculateTotal = (colIndex) => {

        if (!isNumber(cleanNumberString(rows[0][colIndex]))) return '';

        let total = 0;

        rows.forEach(row => {
            const cell = row[colIndex];

            if (cell.length > 0) total += parseFloat(cleanNumberString(cell));
        });

        return total;
    }

    // Cleans a number string. Remove parenthesis and stuff
    const cleanNumberString = (string) => {

        // Don't clean if there is no percentage
        if (!hasPercentage(string)) return string;

        const cleaned = string.slice(0, ( string.indexOf('(') -1 ))
        return cleaned
    }

    const formatPercentage = (string) => {
        if (isNumber(cleanNumberString(string)) && hasPercentage(string)) {
            const number = cleanNumberString(string)
            const percentage = string.slice(string.indexOf('('))
            const formatted = `${number} <span class='percentage'>${percentage}</span>`
            return formatted;
        }

        return string
    }

    onMount(async () => {
	});

    //const textBlocks = JSON.parse(tables.table).blocks
    //console.log(textBlocks)
</script>

<span class="anim-wrapper">
    <p>{@html formatDescription(description)}</p>
</span>

<span class="anim-wrapper">
    <table class='factsheet-table'>
        <thead>
            <tr>
                {#each headers as header}
                <th>{header}</th>
                {/each}
            </tr>
        </thead>
        <tbody>
            {#each rows as row}
            <tr>
                {#each row as cell}
                <td>{@html formatPercentage(cell)}</td>
                {/each}
            </tr>
            {/each}
        </tbody>
        {#if rows.length > 0}
        <tfoot>
            <tr>
                <th scope="row">Total:</th>
                {#each rows[0].slice(1) as row, index}
                    <td>{calculateTotal(index + 1)}</td>
                {/each}
            </tr>
        </tfoot>
        {/if}
    </table>
</span>